const React = require("react");

function PlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 4v16m8-8H4"
  }));
}

module.exports = PlusIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/PlusIcon.js
 ** module id = 586
 ** module chunks = 0
 **/